import Auth from './auth.vue';
export default Auth;



// WEBPACK FOOTER //
// ./src/components/auth/index.js